<template>
    <div class="popup-overlay">
      <div class="popup-content">
        <h2>신청을 취소하시겠습니까?</h2>
        <h4>잔여세션이 남아있지 않을경우, 신청이 불가할 수 있습니다.</h4><br>
        <!-- <div v-for="item in cancelEndPointData" :key="item.idx" class="popup-text-left"> -->
          <!-- <span style="font-weight: bold; font-size: 15px;">{{item.session_name}} {{item.session_time}}</span><br> -->
          <!-- <span style="color:#5e82fc;">(잔여수량 : {{item.remainSeat}} 세트)</span><br> -->
        <!-- </div> -->
        <br>
        <button class="bt-akl-blue large NCACroa_submit" style="border-radius: 8px;" @click="cancelConfirm">예</button>
        <button class="bt-akl-blue large NCACroa_submit" style="border-radius: 8px;" @click="popupClose">아니오</button>
      </div>
    </div>
  </template>
  
  <style scoped>
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent gray background */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popup-content {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    text-align: center;
  }
  .popup-text-left {
    width: 100%;
    text-align: left;
    margin-left: 10px;
    margin-top: 5px;
    padding: 10px;
    text-align: center;
    padding: 20px;
  }
  </style>
  <!-- #5e82fc; -->
  <script>
  export default {
    props: {
      cancelEndPointData: Array
    },
    data() {
      return {};
    },
    methods: {
        // 예 버튼 클릭 시 신청취소
        cancelConfirm () {
            this.$emit('cancelConfirm',true)
        },
        // 아니오 버튼 클릭 시 팝업닫기 및 본화면유지.
        popupClose () {
            this.$emit('popupClose',false)
        }
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/views/taola/component/WouldUrideCancelConfrim.vue